module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/my_answer.82035.png";